

function NotFound(props) {
    return (
        <p>抱歉，您访问的页面不存在。</p>
    );
}

export default NotFound;